import { render, staticRenderFns } from "./ConsumedBarChart.vue?vue&type=template&id=20803ccc&"
import script from "./ConsumedBarChart.vue?vue&type=script&lang=ts&"
export * from "./ConsumedBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports